var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrowUpBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#21252A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.236 20.588c.332 0 .603-.104.81-.313.21-.208.313-.485.313-.83V8.381l-.08-1.995 2.229 2.503 2.11 2.08c.103.11.222.195.356.254.133.058.281.088.444.088.3 0 .552-.101.757-.303.205-.202.307-.46.307-.772 0-.306-.117-.576-.351-.81l-6.055-6.074c-.11-.118-.24-.206-.386-.264-.146-.059-.297-.088-.454-.088-.15 0-.298.03-.444.088-.146.058-.275.146-.386.264L5.352 9.426c-.235.234-.352.504-.352.81 0 .313.1.57.303.772.202.202.459.303.771.303.163 0 .31-.03.44-.088.13-.059.247-.144.351-.254l2.11-2.08 2.228-2.519-.08 2.01v11.065c0 .345.103.622.308.83.205.209.473.313.805.313z",
    transform: "translate(-168.000000, -2268.000000) translate(158.000000, 2258.000000) translate(10.000000, 10.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUpBlack);
export default __webpack_public_path__ + "static/media/ic_arrow_up_black.f5dea7c8319f32b036a5cd461bf7fb8b.svg";
export { ForwardRef as ReactComponent };